import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import ICONS from './iconData';

export const svgFill = color => ({
  '& *[fill="red"]': {
    fill: color,
    transition: 'all ease-in-out 100ms'
  },
  '& *[stroke="red"]': {
    stroke: color,
    transition: 'all ease-in-out 100ms'
  }
});

const useStyles = makeStyles(theme => ({
  custom: {
    flexShrink: 0
  },
  large: {
    width: 48,
    height: 48,
    flexShrink: 0
  },
  medium: {
    width: 32,
    height: 32,
    flexShrink: 0
  },
  small: {
    width: 24,
    height: 24,
    flexShrink: 0
  },
  xs: {
    width: 16,
    height: 16,
    flexShrink: 0
  },
  xss: {
    width: 12,
    height: 12,
    flexShrink: 0
  },
  primary: {
    ...svgFill(theme.palette.primary.main)
  },
  primaryContrast: {
    ...svgFill(theme.palette.primary.contrastText)
  },
  secondary: {
    ...svgFill(theme.palette.secondary.main)
  },
  secondaryContrast: {
    ...svgFill(theme.palette.secondary.contrastText)
  },
  warningDark: {
    ...svgFill(theme.palette.warning.dark)
  },
  textPrimary: {
    ...svgFill(theme.palette.text.primary)
  },
  hint: {
    ...svgFill(theme.palette.text.hint)
  },
  disabled: {
    ...svgFill(theme.palette.text.disabled)
  }
}));

const CustomIcon = ({ id, className, icon, size, variant }) => {
  const classes = useStyles();
  const SvgIcon = ICONS[icon];

  return (
    <SvgIcon
      id={id}
      className={classNames(classes[size], classes[variant], className)}
      role="img"
    />
  );
};

export default CustomIcon;
